import {vendorsConstants} from '../constants';

const vendorsState = {
  vendors: []
};

const vendorReducer = (state = vendorsState, action) => {
  const {type, data} = action;
  switch (type) {
    case vendorsConstants.GET_VENDORS:
      return {
        ...state,
        vendors: data
      }
    case vendorsConstants.STORE_BATCH_VENDORS:
      return {
        ...state,
        vendors: [...state.vendors, ...data]
      }
    case vendorsConstants.CLEAR_VENDORS:
      return vendorsState
    default:
      return state;
  }
};

export default vendorReducer;
